import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabeledSelect = _resolveComponent("LabeledSelect")!

  return (_openBlock(), _createBlock(_component_LabeledSelect, _mergeProps(_ctx.labelSelectAttributes, {
    loading: _ctx.$fetchState.pending,
    options: _ctx.allOfType,
    paginate: _ctx.paginate ? _ctx.paginateType : undefined,
    multiple: _ctx.$attrs.multiple || false,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:value', $event)))
  }), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
        ])
      }
    })
  ]), 1040, ["loading", "options", "paginate", "multiple"]))
}